import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatureFlags } from '../../contexts/FeatureFlagContext';

const ReceivablesFeatureGate = ({ children }) => {
  const { receivables: receivablesEnabled } = useFeatureFlags();

  if (!receivablesEnabled) {
    return <Navigate to="/orders" replace />;
  }

  return children;
};

export default ReceivablesFeatureGate;
